<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">PSM Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newPsm()">New PSM</a>
					<a href="#" @click="savePsm()" v-if="psm">Save</a>
					<a href="#" @click="deleteSelected()" v-if="psm">Delete</a>
					<a href="#" @click="onLoad()" v-if="psm">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">

		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

		<div class="row">
			<div class="col-md-3 mb-4">
				<h2>PSMs</h2>
				<div class="row mb-1" v-for="p in psms" :key="p.id">
					<b-button @click="selectPsm(p)">{{p.name}}</b-button>
				</div>
				<div class="row mb-1" v-if="psm">
					<b-button @click="savePsm()" variant="primary"><b-icon-save font-scale="1.5"/> Save Current PSM</b-button>
				</div>
				<div class="row mt-2 mb-1">
					<b-button @click="newPsm()" variant="success"><b-icon-plus font-scale="1.5"/> New PSM</b-button>
				</div>
				<div class="row mb-1" v-if="psm">
					<b-button @click="deleteSelected()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Current PSM</b-button>
				</div>
			</div>
			<div class="col-md-9" v-if="psm">
				<div class="m-5 mt-0">
					<h2>{{psm.name}}</h2>
					<div class="mb-2"><small>ID: {{psm.id}}</small></div>
					Name: <b-form-input class="mb-2" v-model="psm.name"></b-form-input>
					Priority: <b-form-input class="mb-2" v-model="psm.priority"></b-form-input>
					Title: <b-form-input class="mb-2" v-model="psm.title"></b-form-input>
					Tag Line: <b-form-input class="mb-2" v-model="psm.tagLine"></b-form-input>
					Feature tags (admin only): <b-form-input class="mb-2" v-model="psm.featureTags"></b-form-input>
					Description: <b-form-textarea class="mb-2" v-model="psm.description"></b-form-textarea>
					Time to Complete (mins): <b-form-input class="mb-2" v-model="psm.timeToComplete"></b-form-input>
					Delay after customer delay (days): <b-form-input class="mb-2" v-model="psm.defaultDelayPeriodDays"></b-form-input>
					Delay after actioned (days): <b-form-input class="mb-2" v-model="psm.delayAfterActionDays"></b-form-input>
					Action Button Text: <b-form-input class="mb-2" v-model="psm.actionButtonText"></b-form-input>
					Background Image: <b-form-input class="mb-2" v-model="psm.backgroundImage"></b-form-input>
					<div><b-img class="mb-2" width="200" thumbnail :src="psm.backgroundImage"></b-img></div>
					Background Video: <b-form-input class="mb-2" v-model="psm.backgroundVideo"></b-form-input>
					Thumbnail: <b-form-input class="mb-2" v-model="psm.thumbnail"></b-form-input>
					<div><b-img class="mb-2" width="200" thumbnail :src="psm.thumbnail"></b-img></div>
					App Screen: <b-form-input class="mb-2" v-model="psm.appScreen"></b-form-input>
					CMS Page: <b-form-input class="mb-2" v-model="psm.cmsPage"></b-form-input>
					Website URL: <b-form-input class="mb-2" v-model="psm.websiteUrl"></b-form-input>
					<div id="criteria">
						<b-button class="btn-sm" v-for="c in criteria" :key="c" @click="psm.criteria += c">{{c}}</b-button>
					</div>
					Criteria: <b-form-input class="mb-2" v-model="psm.criteria"></b-form-input>
					Dark Mode: <b-form-checkbox class="mb-2" v-model="psm.darkMode"></b-form-checkbox>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'PSMs',
  data() {
	return{
		psms: null,
		psm: null,
		message: null,
		error: null,
		criteria: [
"BU_HasAppBudget",
"B_AveragePayDay",
"B_CreditCardsAmountOustanding",
"B_CreditCardsDebtToNetMonthlyPayRatio",
"B_DirectDebitsCount",
"B_DirectDebitsToNetMonthlyPayRatio",
"B_MonthlyDirectDebitsTotal",
"B_NetMonthlyIncome",
"B_SavingsToNetMonthlyPayRatio",
"B_SurplusMonthlyIncomeAfterDDs",
"B_TotalSavings",
"B_UncategorizedTransactionsPercentage",
"B_UncategorizedTransactions",
"B_HasSpendingPlan",
"B_PlanSum",
"B_AvgCycleSpendSum",
"CH_CreditAccounts",
"CH_CreditBalance",
"CH_CreditScore",
"CH_HasCreditInfo",
"CH_HasMortgage",
"CH_MortgageDealExpiry",
"CH_MortgageOnDeal",
"CreateDateTime",
"F_CreditCardsAmountOustandingDecreased",
"F_CreditCardsAmountOustandingIncreased",
"F_HasMortgage",
"F_MonthlyDirectDebitsTotalDecreased",
"F_MonthlyDirectDebitsTotalIncreased",
"F_NetMonthlyIncomeDecreased",
"F_NetMonthlyIncomeIncreased",
"F_PropertyEquity",
"F_TotalSavingsDecreased",
"F_TotalSavingsIncreased",
"E_SpendingAnalysisPageViewedCount",
"E_SpendingAnalysisPageLastViewed",
"E_ReflectionsPageLastViewed",
"IH_BuildingsInsuranceExpiring",
"IH_ContentsInsuranceExpiring",
"IH_GadgetInsuranceExpiring",
"IH_HasBuildingsInsurance",
"IH_HasContentsInsurance",
"IH_HasGadgetInsurance",
"IH_HasLifeInsurance",
"IH_HasPetInsurance",
"IH_HasTravelInsurance",
"IH_HasVehicleInsurance",
"IH_LifeInsuranceExpiring",
"IH_PetInsuranceExpiring",
"IH_TravelInsuranceExpiring",
"IH_UsesInsuranceHub",
"IH_VehicleInsuranceExpiring",
"IV_TotalPension",
"SI_NumMGSavingsAccounts",
"OriginalCustomerID",
"Q_HasCashISA",
"Q_HasInvestmentISA",
"Q_HasLifetimeISA",
"Q_IsContributingToPension",
"Q_MonthsOfSavings",
"Q_MortgageAmountOutstanding",
"Q_MortgageRate",
"Q_MortgageRateEnds",
"Q_MortgageRateIsDiscounted",
"Q_PropertyOwner",
"Q_PropertyValue",
"Q_RegularSaver",
"Q_Salary",
"WB_DaysSinceCheckIn",
"WB_RecentScoreSum",
"WB_EducationPillarScore",
"WB_ManagingDebtPillarScore",
"WB_PlanningPillarScore",
"WB_ProtectionPillarScore",
"WB_SavingsPillarScore",
"WB_SpendingPillarScore",

		]
	}
  },
  methods: {
	getPsms: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Moves")
			.then((result) => {
				this.psms = result.data;
				if (autoSelect) {
					if (this.psms.length > 0) {
						this.psm = this.psms[0];
					}
				}
			}
		)
	},
	selectPsm: function(p) {
		this.psm = p;
	},
	savePsm: function(){
		if (this.psm.id == null) {
			this.$http.post(this.$config.ApiUri + "/Moves", this.psm)
				.then((result) => {
					this.psm = result.data;
					this.getPsms(false);
					this.showMessage("PSM created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Moves/" + this.psm.id, this.psm)
				.then((result) => {
					this.psm = result.data;
					this.getPsms(false);
					this.showMessage("PSM saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Moves/" + this.psm.id)
			.then(() => {
				this.psm = null;
				this.getPsms(true);
				this.showMessage("PSM deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that PSM cannot be deleted.  This may mean moves have already been generated against it.  We cannot rewrite history. (" + error + ")"); });
	},
	newPsm() {
		this.psm = { 
			"criteria": "",
			"financialRank": 0,
			"wellbeingRank": 0,
			"validFrom": "2022-03-15",
			"validTo": "2029-03-15",
			"defaultDelayPeriodDays": 7,
			"name": "",
			"priority": this.psms.length + 1,
			"title": "",
			"tagLine": "",
			"description": "",
			"actionButtonText": "",
			"backgroundImage": "",
			"backgroundVideo": "",
			"thumbnail": "",
			"darkMode": false,
			"websiteUrl": "",
			"appScreen": "",
			"cmsPage": "",
			"timeToComplete": 0
		};
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getPsms(false);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
</style>